import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button, Form, Label, Col, FormGroup } from 'reactstrap';
import _ from 'lodash';
import { sharedLabelsPath } from "../../../../reducers/common/localization";
import { SUB_ROLES, SUB_ROLES_TRANSLATIONS } from '../../../../reducers/account/role';
import SelectWithSearch from "../../../commonComponents/selectWithSearch/SelectWithSearch";
import Select from "../../../commonComponents/customSelect/CustomSelect.container";

const AVAILABLE_ROLES = [SUB_ROLES.HM, SUB_ROLES.BO];

class AddEmployeeToDepartmentModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            employeeId: null,
            role: ''
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isOpen && !this.props.isOpen) {
            this.cleanState();
        }
    }

    render() {
        return (
            <Modal className="department-modal" isOpen={this.props.isOpen}
                toggle={this.handleCancel}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <Form onSubmit={this.handleSubmit}>
                <FormGroup row>
                    <Label sm={3}>{_.get(this.props.translation, 'org_staff.departments.role_label') + '*'}</Label>
                    <Col sm={9}>
                        <Select id={'employee-role-select'}
                                selectedOption={_.find(this.getRolesOptions(), option => option.value === this.state.role)}
                                options={this.getRolesOptions()}
                                onSelect={this.handleChange('role')}
                                placeholder={_.get(this.props.translation, 'org_staff.departments.role_input_placeholder')}
                                isSearchable={false}/>
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label sm={3}>{_.get(this.props.translation, 'org_staff.departments.employee_label') + '*'}</Label>
                    <Col sm={9}>
                        <SelectWithSearch
                            value={this.state.employeeId}
                            onChange={this.handleChangeEmployeeId}
                            isDisabled={this.state.role === ''}
                            options={this.getEmployeesOptions()}
                            placeholder={_.get(this.props.translation, 'org_staff.departments.employee_input_placeholder')}
                        />
                    </Col>
                </FormGroup>
                <div className="modal-buttons-container">
                    <Button color="secondary" type='submit' onClick={this.handleCancel}>
                        {_.get(this.props.translation, sharedLabelsPath.cancel_button)}
                    </Button>
                    <Button className="olive-green-btn" type='submit'
                            disabled={_.isNil(this.state.employeeId) || this.state.role === ''}>
                        {_.get(this.props.translation, sharedLabelsPath.add_button)}
                    </Button>
                </div>
            </Form>
        );
    }

    handleChangeEmployeeId = (value) => {
        this.setState({ employeeId: value });
    };

    handleChange = (fieldName) => (selectedOption) => {
        this.setState({ [fieldName]: selectedOption.value });
    };

    getEmployeesOptions = () => {
        return _.chain(this.props.staffMembersData)
            .filter((employee) => {
                switch (this.state.role) {
                    case SUB_ROLES.HM:
                        return !_.includes(this.props.hmList, employee.id);
                    case SUB_ROLES.BO:
                        return !_.includes(this.props.boList, employee.id);
                    default:
                        return false;
                }
            })
            .map(employee => (
                {value: employee.id, label: `${employee.firstName} ${employee.lastName} (${employee.email})`}
            ))
            .value();
    };

    getRolesOptions = () => {
        return _.map(AVAILABLE_ROLES, role => ({value: role, label: _.get(this.props.translation, 'roles.' + SUB_ROLES_TRANSLATIONS[role])}));
    };

    handleCancel = (e) => {
        e.preventDefault();

        this.cleanState();
        this.props.onCancel();
    };

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.onEmployeeAddToDepartment(this.props.departmentId, this.state.employeeId, this.state.role);
    };

    cleanState = () => {
        this.setState({
            employeeId: null,
            role: ''
        });
    };
}

AddEmployeeToDepartmentModal.propTypes = {
    departmentId: PropTypes.string,
    staffMembersData: PropTypes.array,
    hmList: PropTypes.array,
    boList: PropTypes.array,
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    onEmployeeAddToDepartment: PropTypes.func,
    onCancel: PropTypes.func
};

export default AddEmployeeToDepartmentModal;



// WEBPACK FOOTER //
// ./src/components/staffMemberManagement/departmentModal/addEmployeeToDepartmentModal/AddEmployeeToDepartmentModal.js